import { FC } from 'react';
import './myIcon.less';
import arrowDown from '../assets/arrow-down_shurukuang@2X.svg';

const SelectRightImg: FC<any> = () => {
  return <img alt='' src={arrowDown} className='select-right-img' />;
};

export default SelectRightImg;
